export type LanguageCode = 'it' | 'en';

interface Translations {
  [key: string]: {
    [key in LanguageCode]: string;
  };
}

export const translations: Translations = {
  // Navbar
  'nav.home': {
    it: 'Home',
    en: 'Home',
  },
  'nav.accommodations': {
    it: 'Proprietà',
    en: 'Properties',
  },
  'nav.attractions': {
    it: 'Attrazioni',
    en: 'Attractions',
  },
  'nav.about': {
    it: 'Chi Siamo',
    en: 'About Us',
  },
  'nav.book': {
    it: 'Contattaci',
    en: 'Contact Us',
  },
  
  // Common
  'common.back': {
    it: 'Indietro',
    en: 'Back',
  },
  'common.discover': {
    it: 'Scopri',
    en: 'Discover',
  },
  'common.see_more': {
    it: 'Vedi Altro',
    en: 'See More',
  },
  'common.learn_more': {
    it: 'Scopri di Più',
    en: 'Learn More',
  },
  'common.view_all': {
    it: 'Vedi Tutti',
    en: 'View All',
  },
  'common.from': {
    it: 'Da',
    en: 'From',
  },
  'common.night': {
    it: 'notte',
    en: 'night',
  },
  'common.explore': {
    it: 'Esplora',
    en: 'Explore',
  },

  // Regions and Locations
  'region.tuscany': {
    it: 'Toscana',
    en: 'Tuscany',
  },
  'region.liguria': {
    it: 'Liguria',
    en: 'Liguria',
  },
  'location.downtown': {
    it: 'Centro città',
    en: 'Downtown',
  },
  'location.beachfront': {
    it: 'Fronte mare',
    en: 'Beachfront',
  },
  'location.cultural_district': {
    it: 'Quartiere culturale',
    en: 'Cultural District',
  },

  // Homepage
  'home.hero.title': {
    it: 'Alloggi e Gestione Immobiliare di Lusso',
    en: 'Luxury Accommodations & Property Management',
  },
  'home.hero.subtitle': {
    it: 'Vivi la perfetta combinazione di comfort ed eleganza con le nostre proprietà premium in affitto a breve termine e i nostri servizi di gestione completi.',
    en: 'Experience the perfect blend of comfort and elegance with our premium short-term rental properties and comprehensive management services.',
  },
  'home.hero.button': {
    it: 'Esplora Proprietà',
    en: 'Explore Properties',
  },
  'home.services.title': {
    it: 'I Nostri Servizi in Evidenza',
    en: 'Our Featured Services',
  },
  'home.services.subtitle': {
    it: 'Scopri come possiamo trasformare la tua esperienza immobiliare con la nostra gamma completa di servizi premium.',
    en: 'Discover how we can transform your property experience with our comprehensive range of premium services.',
  },
  'home.services.luxury_accommodations.title': {
    it: 'Alloggi di Lusso',
    en: 'Luxury Accommodations',
  },
  'home.services.luxury_accommodations.description': {
    it: 'Vivi il massimo del comfort e dello stile nella nostra selezione curata di proprietà premium in affitto a breve termine, perfette sia per viaggiatori leisure che business.',
    en: 'Experience the epitome of comfort and style in our curated selection of premium short-term rental properties, perfect for both leisure and business travelers.',
  },
  'home.services.exclusive_locations.title': {
    it: 'Location Esclusive',
    en: 'Exclusive Locations',
  },
  'home.services.exclusive_locations.description': {
    it: 'Dai vivaci centri città ai tranquilli rifugi, le nostre proprietà sono situate in posizioni privilegiate, offrendo la cornice perfetta per il tuo soggiorno.',
    en: 'From vibrant city centers to serene retreats, our properties are situated in prime locations, offering the perfect backdrop for your stay.',
  },
  'home.services.property_management.title': {
    it: 'Gestione Immobiliare',
    en: 'Property Management',
  },
  'home.services.property_management.description': {
    it: 'Lascia che ci occupiamo delle complessità della gestione immobiliare con i nostri servizi completi su misura per massimizzare il ritorno del tuo investimento.',
    en: 'Let us handle the complexities of property management with our comprehensive services tailored to maximize your investment return.',
  },
  'home.about.title': {
    it: 'Chi è J-O-H',
    en: 'About J-O-H',
  },
  'home.about.text1': {
    it: 'In J-O-H, crediamo nel trasformare soggiorni ordinari in esperienze straordinarie. Fondati con una passione per il lusso e l\'attenzione ai dettagli, curiamo e gestiamo proprietà eccezionali che soddisfano i più alti standard di comfort ed eleganza.',
    en: 'At J-O-H, we believe in transforming ordinary stays into extraordinary experiences. Founded with a passion for luxury and attention to detail, we curate and manage exceptional properties that meet the highest standards of comfort and elegance.',
  },
  'home.about.text2': {
    it: 'Il nostro team combina competenza del settore con un servizio personalizzato per garantire che sia i proprietari che gli ospiti ricevano un valore senza pari. Che tu stia cercando un soggiorno memorabile o desideri ottimizzare la tua proprietà, J-O-H offre eccellenza in ogni punto di contatto.',
    en: 'Our team combines industry expertise with personalized service to ensure both property owners and guests receive unparalleled value. Whether you\'re seeking a memorable stay or looking to optimize your property\'s potential, J-O-H delivers excellence at every touchpoint.',
  },
  'home.featured_accommodations.title': {
    it: 'Alloggi in Evidenza',
    en: 'Featured Accommodations',
  },
  'home.featured_accommodations.subtitle': {
    it: 'Esplora la nostra selezione di alloggi di lusso, progettati per offrire il massimo comfort e stile per il tuo soggiorno.',
    en: 'Explore our handpicked selection of luxury accommodations, designed to provide the ultimate comfort and style for your stay.',
  },
  'home.featured_accommodations.card1.title': {
    it: 'Appartamento Moderno in Centro',
    en: 'Modern Downtown Apartment',
  },
  'home.featured_accommodations.card1.subtitle': {
    it: 'Centro Città, 2 numero ospiti',
    en: 'City Center, 2 guests',
  },
  'home.featured_accommodations.card1.description': {
    it: 'Vivi il meglio della vita urbana in questo elegante appartamento con vista panoramica sulla città e comfort contemporanei.',
    en: 'Experience urban living at its finest in this stylish apartment featuring panoramic city views and contemporary amenities.',
  },
  'home.featured_accommodations.card2.title': {
    it: 'Villa sul Mare',
    en: 'Seaside Villa Retreat',
  },
  'home.featured_accommodations.card2.subtitle': {
    it: 'Area Costiera, 3 numero ospiti',
    en: 'Coastal Area, 3 guests',
  },
  'home.featured_accommodations.card2.description': {
    it: 'Fuggi in questa tranquilla villa sul mare che offre una vista mozzafiato sull\'oceano e accesso diretto alla spiaggia per una vacanza perfetta.',
    en: 'Escape to this tranquil seaside villa offering breathtaking ocean views and direct beach access for the perfect getaway.',
  },
  'home.featured_accommodations.card3.title': {
    it: 'Loft Storico',
    en: 'Historic Loft Residence',
  },
  'home.featured_accommodations.card3.subtitle': {
    it: 'Quartiere Culturale, 1 numero ospiti',
    en: 'Cultural District, 1 guest',
  },
  'home.featured_accommodations.card3.description': {
    it: 'Immergiti nella cultura e nella storia in questo loft splendidamente restaurato con elementi architettonici originali e comfort moderni.',
    en: 'Immerse yourself in culture and history in this beautifully restored loft featuring original architectural elements and modern comforts.',
  },
  'home.featured_accommodations.view_all': {
    it: 'Vedi Tutti gli Alloggi',
    en: 'View All Accommodations',
  },
  'home.popular_attractions.title': {
    it: 'Attrazioni Popolari',
    en: 'Popular Attractions',
  },
  'home.popular_attractions.subtitle': {
    it: 'Scopri emozionanti attrazioni ed esperienze vicino alle nostre proprietà per rendere il tuo soggiorno davvero memorabile.',
    en: 'Discover exciting attractions and experiences near our properties to make your stay truly memorable.',
  },
  'home.popular_attractions.card1.title': {
    it: 'Museo d\'Arte della Città',
    en: 'City Art Museum',
  },
  'home.popular_attractions.card1.subtitle': {
    it: 'Quartiere Culturale, 2 miglia dal centro',
    en: 'Cultural District, 2 miles from downtown',
  },
  'home.popular_attractions.card1.description': {
    it: 'Esplora una delle collezioni d\'arte più complete della regione, con capolavori classici e opere contemporanee.',
    en: 'Explore one of the most comprehensive art collections in the region, featuring both classical masterpieces and contemporary works.',
  },
  'home.popular_attractions.card2.title': {
    it: 'Sentiero Costiero',
    en: 'Coastal Walking Trail',
  },
  'home.popular_attractions.card2.subtitle': {
    it: 'Area Marittima, accessibile dalle proprietà fronte mare',
    en: 'Seaside Area, accessible from beachfront properties',
  },
  'home.popular_attractions.card2.description': {
    it: 'Goditi viste mozzafiato lungo questo pittoresco sentiero costiero, perfetto per passeggiate mattutine o al tramonto.',
    en: 'Experience breathtaking views along this scenic coastal pathway, perfect for morning walks or sunset strolls.',
  },
  
  // Accommodations
  'accommodations.title': {
    it: 'Proprietà',
    en: 'Properties',
  },
  'accommodations.filter.all': {
    it: 'Tutti',
    en: 'All',
  },
  'accommodations.filter.tuscany': {
    it: 'Toscana',
    en: 'Tuscany',
  },
  'accommodations.filter.liguria': {
    it: 'Liguria',
    en: 'Liguria',
  },
  'accommodations.filter.penthouses': {
    it: 'Attici',
    en: 'Penthouses',
  },
  'accommodations.filter.castles': {
    it: 'Castelli',
    en: 'Castles',
  },
  'accommodations.filter.villas': {
    it: 'Ville',
    en: 'Villas',
  },
  'accommodations.filter.apartments': {
    it: 'Appartamenti',
    en: 'Apartments',
  },
  'bedrooms': {
    it: 'numero ospiti',
    en: 'number of guests',
  },
  'bathrooms': {
    it: 'bagni',
    en: 'bathrooms',
  },
  'amenities': {
    it: 'Servizi',
    en: 'Amenities',
  },
  'terrace': {
    it: 'terrazza',
    en: 'terrace',
  },
  'accommodations.description': {
    it: 'Esplora la nostra collezione esclusiva di alloggi di lusso in Italia. Ville, appartamenti e case vacanza per un soggiorno indimenticabile.',
    en: 'Explore our exclusive collection of luxury accommodations in Italy. Villas, apartments, and vacation homes for an unforgettable stay.',
  },
  'accommodations.page_title': {
    it: 'Proprietà di Lusso in Italia | J-O-H',
    en: 'Luxury Properties in Italy | J-O-H',
  },
  'accommodations.seo_keywords': {
    it: 'alloggi di lusso, ville italiane, appartamenti di prestigio, case vacanza, affitti brevi',
    en: 'luxury accommodations, italian villas, prestigious apartments, vacation homes, short-term rentals',
  },
  'accommodations.beds': {
    it: 'letti',
    en: 'beds',
  },
  'accommodations.size': {
    it: 'dimensione',
    en: 'size',
  },
  'accommodations.map_title': {
    it: 'Mappa interattiva delle proprietà',
    en: 'Interactive Property Map',
  },
  
  // Attractions
  'attractions.title': {
    it: 'Attrazioni',
    en: 'Attractions',
  },
  'attractions.search': {
    it: 'Cerca per città',
    en: 'Search by city',
  },
  'attractions.no_results_title': {
    it: 'Nessun risultato trovato',
    en: 'No results found',
  },
  'attractions.no_results_text': {
    it: 'Prova a modificare i tuoi termini di ricerca o esplora tutte le nostre destinazioni',
    en: 'Try modifying your search terms or browse all our destinations',
  },
  'attractions.destination': {
    it: 'destinazione',
    en: 'destination',
  },
  'attractions.destinations': {
    it: 'destinazioni',
    en: 'destinations',
  },
  
  // City
  'city.not_found': {
    it: 'Città non trovata',
    en: 'City not found',
  },
  'city.back_to_attractions': {
    it: 'Torna alle attrazioni',
    en: 'Back to attractions',
  },
  'city.what_to_see': {
    it: 'COSA VEDERE',
    en: 'WHAT TO SEE',
  },
  'city.surroundings': {
    it: 'NEI DINTORNI',
    en: 'SURROUNDINGS',
  },
  'city.what_to_do': {
    it: 'COSA FARE',
    en: 'WHAT TO DO',
  },
  'city.useful_info': {
    it: 'ALTRE INFORMAZIONI UTILI',
    en: 'OTHER USEFUL INFORMATION',
  },
  
  // About
  'about.title': {
    it: 'Chi Siamo',
    en: 'About Us',
  },
  'about.hero.subtitle': {
    it: 'Scopri la nostra storia, i nostri valori e il team appassionato dietro i nostri alloggi e servizi di lusso.',
    en: 'Discover our story, our values, and the passionate team behind our luxury accommodations and services.',
  },
  'about.alt.image': {
    it: 'J-O-H Esperienza di Lusso',
    en: 'J-O-H Luxury Experience',
  },
  'about.our_story': {
    it: 'La Nostra Storia',
    en: 'Our Story',
  },
  'about.story.paragraph1': {
    it: 'Fondato nel 2010, J-O-H è nato da un impegno appassionato per trasformare il panorama dell\'ospitalità. I nostri fondatori, viaggiatori esperti e investitori immobiliari, hanno riconosciuto una lacuna nel mercato per alloggi a breve termine davvero eccezionali, abbinati a servizi completi di gestione immobiliare.',
    en: 'Founded in 2010, J-O-H emerged from a passionate commitment to transforming the hospitality landscape. Our founders, seasoned travelers and property investors, recognized a gap in the market for truly exceptional short-term accommodations coupled with comprehensive property management services.',
  },
  'about.story.paragraph2': {
    it: 'Quello che è iniziato come una collezione curata di cinque proprietà esclusive si è trasformato in un portafoglio diversificato che abbraccia più città e tipologie di proprietà. Durante la nostra crescita, siamo rimasti costanti nel nostro impegno per l\'eccellenza, la personalizzazione e la creazione di esperienze memorabili.',
    en: 'What began as a curated collection of five exclusive properties has blossomed into a diverse portfolio spanning multiple cities and property types. Throughout our growth, we\'ve remained steadfast in our commitment to excellence, personalization, and creating memorable experiences.',
  },
  'about.story.paragraph3': {
    it: 'Oggi, J-O-H si erge come un faro di lusso nel settore degli affitti a breve termine e della gestione immobiliare, di fiducia sia per gli ospiti esigenti che per i proprietari di immobili.',
    en: 'Today, J-O-H stands as a beacon of luxury in the short-term rental and property management industry, trusted by discerning guests and property owners alike.',
  },
  'about.our_values': {
    it: 'I Nostri Valori',
    en: 'Our Values',
  },
  'about.values.excellence.title': {
    it: 'Eccellenza',
    en: 'Excellence',
  },
  'about.values.excellence.description': {
    it: 'Perseguiamo l\'eccellenza in ogni dettaglio, dalla selezione e manutenzione delle proprietà alle esperienze degli ospiti e alle comunicazioni con i proprietari.',
    en: 'We pursue excellence in every detail, from property selection and maintenance to guest experiences and owner communications.',
  },
  'about.values.luxury.title': {
    it: 'Lusso',
    en: 'Luxury',
  },
  'about.values.luxury.description': {
    it: 'Crediamo nel creare ambienti in cui il lusso non è solo una caratteristica ma un\'esperienza globale.',
    en: 'We believe in creating environments where luxury isn\'t just a feature but an all-encompassing experience.',
  },
  'about.values.service.title': {
    it: 'Servizio',
    en: 'Service',
  },
  'about.values.service.description': {
    it: 'Il servizio eccezionale è la pietra angolare della nostra attività, riflessa nella nostra reattività, attenzione ai dettagli e desiderio di superare le aspettative.',
    en: 'Exceptional service is the cornerstone of our business, reflected in our responsiveness, attention to detail, and desire to exceed expectations.',
  },
  'about.values.integrity.title': {
    it: 'Integrità',
    en: 'Integrity',
  },
  'about.values.integrity.description': {
    it: 'Conduciamo la nostra attività con integrità incrollabile, promuovendo trasparenza e fiducia in tutte le nostre relazioni.',
    en: 'We conduct our business with unwavering integrity, fostering transparency and trust in all our relationships.',
  },
  'about.values.community.title': {
    it: 'Comunità',
    en: 'Community',
  },
  'about.values.community.description': {
    it: 'Crediamo nel restituire alle comunità in cui si trovano le nostre proprietà, sostenendo le imprese locali e il turismo sostenibile.',
    en: 'We believe in giving back to the communities where our properties are located, supporting local businesses and sustainable tourism.',
  },
  'about.our_impact': {
    it: 'Il Nostro Impatto',
    en: 'Our Impact',
  },
  'about.properties_managed': {
    it: 'Proprietà Gestite',
    en: 'Properties Managed',
  },
  'about.happy_clients': {
    it: 'Clienti Soddisfatti',
    en: 'Happy Clients',
  },
  'about.cities_covered': {
    it: 'Città Coperte',
    en: 'Cities Covered',
  },
  'about.years_experience': {
    it: 'Anni di Esperienza',
    en: 'Years Experience',
  },
  'about.ready_for_luxury': {
    it: 'Pronto a Vivere il Lusso?',
    en: 'Ready to Experience Luxury?',
  },
  'about.ready_for_luxury_text': {
    it: 'Che tu stia cercando un alloggio perfetto o una gestione professionale per la tua proprietà, il nostro team è pronto ad assisterti.',
    en: 'Whether you\'re looking for the perfect accommodation or seeking professional management for your property, our team is ready to assist you.',
  },
  'about.our_departments': {
    it: 'I Nostri Dipartimenti',
    en: 'Our Departments',
  },
  'about.values.innovation.title': {
    it: 'Innovazione',
    en: 'Innovation',
  },
  'about.values.innovation.description': {
    it: 'Abbracciamo l\'innovazione tecnologica e le nuove tendenze del settore per offrire soluzioni all\'avanguardia e migliorare costantemente i nostri servizi.',
    en: 'We embrace technological innovation and industry trends to deliver cutting-edge solutions and continuously improve our services.',
  },
  
  // Contact
  'contact.title': {
    it: 'Contattaci',
    en: 'Contact Us',
  },
  'contact.subtitle': {
    it: 'Siamo qui per rispondere alle tue domande. Compila il modulo sottostante e ti risponderemo al più presto.',
    en: 'We\'re here to answer your questions. Fill out the form below and we\'ll get back to you as soon as possible.',
  },
  'contact.form.name': {
    it: 'Nome',
    en: 'Name',
  },
  'contact.form.email': {
    it: 'Email',
    en: 'Email',
  },
  'contact.form.phone': {
    it: 'Telefono',
    en: 'Phone',
  },
  'contact.form.subject': {
    it: 'Oggetto',
    en: 'Subject',
  },
  'contact.form.message': {
    it: 'Messaggio',
    en: 'Message',
  },
  'contact.form.submit': {
    it: 'Invia Messaggio',
    en: 'Send Message',
  },
  'contact.address.title': {
    it: 'Indirizzo',
    en: 'Address',
  },
  'contact.phone.title': {
    it: 'Telefono',
    en: 'Phone',
  },
  'contact.email.title': {
    it: 'Email',
    en: 'Email',
  },
  'contact.hours.title': {
    it: 'Orari di Ufficio',
    en: 'Office Hours',
  },
  'contact.hours.weekdays': {
    it: 'Lunedì - Venerdì: 9:00 - 18:00',
    en: 'Monday - Friday: 9:00 AM - 6:00 PM',
  },
  'contact.hours.weekend': {
    it: 'Sabato: 10:00 - 15:00',
    en: 'Saturday: 10:00 AM - 3:00 PM',
  },
  
  // NotFound
  'notfound.title': {
    it: 'Pagina Non Trovata',
    en: 'Page Not Found',
  },
  'notfound.message': {
    it: 'La pagina che stai cercando non esiste o è stata spostata.',
    en: 'The page you are looking for doesn\'t exist or has been moved.',
  },
  'notfound.button': {
    it: 'Torna alla Home',
    en: 'Back to Home',
  },
  
  // Footer
  'footer.home': {
    it: 'Home',
    en: 'Home',
  },
  'footer.about': {
    it: 'Chi Siamo',
    en: 'About Us',
  },
  'footer.accommodations': {
    it: 'Alloggi',
    en: 'Accommodations',
  },
  'footer.attractions': {
    it: 'Attrazioni',
    en: 'Attractions',
  },
  'footer.services': {
    it: 'Servizi',
    en: 'Services',
  },
  'footer.contact': {
    it: 'Contatti',
    en: 'Contact',
  },
  'footer.become_a_host': {
    it: 'Diventa un Host',
    en: 'Become a Host',
  },
  'footer.rights': {
    it: '© J-O-H HOUSINGS IN ITALY. Powered and secured by JOD',
    en: '© J-O-H HOUSINGS IN ITALY. Powered and secured by JOD',
  },
  'footer.service.property_management': {
    it: 'Gestione Proprietà',
    en: 'Property Management',
  },
  'footer.service.rental': {
    it: 'Affitti a Breve Termine',
    en: 'Short-term Rental',
  },
  'footer.service.consulting': {
    it: 'Consulenza Immobiliare',
    en: 'Real Estate Consulting',
  },
  'footer.service.concierge': {
    it: 'Servizi di Concierge',
    en: 'Concierge Services',
  },
  
  // Legal links
  'legal.terms': {
    it: 'Termini di Servizio',
    en: 'Terms of Service',
  },
  'legal.privacy': {
    it: 'Informativa sulla Privacy',
    en: 'Privacy Policy',
  },
  'legal.cookies': {
    it: 'Informativa sui Cookie',
    en: 'Cookie Policy',
  },
  
  // Header Banner
  'header.banner': {
    it: '- GUARDA CIÒ DI CUI HAI BISOGNO - INFORMATI E AVVIA LA TUA ATTIVITÀ - INIZIA IL TUO REDDITO PASSIVO -',
    en: '- CHECK WHAT YOU NEED - GET INFORMED AND START YOUR BUSINESS - START YOUR PASSIVE INCOME -',
  },
  
  // Layout Banner
  'layout.banner.part1': {
    it: 'SELEZIONA',
    en: 'SELECT',
  },
  'layout.banner.part2': {
    it: 'CIO\' DI CUI HAI BISOGNO',
    en: 'WHAT YOU NEED',
  },
  'layout.banner.part3': {
    it: 'E AGGIUNGILO AL CARRELLO',
    en: 'AND ADD TO CART',
  },
  'layout.banner.part4': {
    it: 'INFORMATI',
    en: 'GET INFORMED',
  },
  'layout.banner.part5': {
    it: 'E AVVIA LA TUA ATTIVITA\'',
    en: 'AND START YOUR BUSINESS',
  },
  'layout.banner.part6': {
    it: 'DAI',
    en: 'START',
  },
  'layout.banner.part7': {
    it: 'INIZIO',
    en: 'YOUR',
  },
  'layout.banner.part8': {
    it: 'ALLA TUA RENDITA PASSIVA',
    en: 'PASSIVE INCOME',
  },
  
  'accommodations.hero.description': {
    it: 'Esplora la nostra collezione esclusiva di alloggi di lusso in Italia. Ville, appartamenti e case vacanza per un soggiorno indimenticabile.',
    en: 'Explore our exclusive collection of luxury accommodations in Italy. Villas, apartments, and vacation homes for an unforgettable stay.',
  },
  'accommodations.hero.title': {
    it: 'Proprietà di Lusso in Italia | J-O-H',
    en: 'Luxury Properties in Italy | J-O-H',
  },
  'accommodations.hero.keywords': {
    it: 'alloggi di lusso, ville italiane, appartamenti di prestigio, case vacanza, affitti brevi',
    en: 'luxury accommodations, italian villas, prestigious apartments, vacation homes, short-term rentals',
  },
}; 